import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { customerPortal } from "@vilocnv/allsetra-core";
import patchGeozoneAction from "../actions/patch-geozone.action";

const patchGeozoneCases = (
  builder: ActionReducerMapBuilder<customerPortal.geozones.GeozonesState>
) => {
  builder.addCase(patchGeozoneAction.pending, (state) => {
    state.isLoadingSelectedGeozone = true;
  });

  builder.addCase(patchGeozoneAction.fulfilled, (state) => {
    state.isLoadingSelectedGeozone = false;
  });

  builder.addCase(patchGeozoneAction.rejected, (state) => {
    state.isLoadingSelectedGeozone = false;
  });
};

export default patchGeozoneCases;
